import { lazy } from 'react'

export const TanStackRouterDevtools = import.meta.env.PROD
  ? (): null => null
  : lazy(() =>
      import('@tanstack/router-devtools').then((result) => ({
        default: result.TanStackRouterDevtools,
      }))
    )
